export default __webpack_public_path__ + "static/media/influenza.c519ccd6.svg";